import './InfoPage.css';
import '../GlobalPages.css';
import { useEffect, useState } from 'react';
import Button from '../../components/shared/button/Button';
import { CurrentUser } from '../../components/login/CurrentUser';
import Navigator from '../../utils/Navigator';
import useSocketClientInfo from '../../components/hooks/useSocketClientInfo';
import SocketClient from '../../services/socket/SocketClient';
import { MessageDialog } from '../../components/messagebox/MessageBox';
import { API } from '../../services/api/API';
import Loader, { LoaderDialog } from '../../components/loader/Loader';
import Delay from '../../utils/Delay';


interface InfoItemProps {
    label: string;
    value: string;
}



function InfoItem({ label, value }: InfoItemProps) {
    return (
        <div className="info-item">
            <span className="info-label">{label}</span>
            <span className="info-value">{value}</span>
        </div>
    );
}

interface InfoSectionProps {
    title: string;
    children: React.ReactNode;
}

function InfoSection({ title, children }: InfoSectionProps) {
    return (
        <div className="info-section">
            <h3 className="section-title">{title}</h3>
            <div className="section-content">
                {children}
            </div>
        </div>
    );
}

export default function InfoPage() {

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const machineInfo = useSocketClientInfo();

    useEffect(() => {

        if (!CurrentUser.User) {
            Navigator.NavigateToHome();
            return;
        }
    });

    async function handleChangePassword() {
        if (!password || !confirmPassword) {
            MessageDialog.Toast("Atenção", "Preencha os campos de senha.");
            return;
        }

        if (password !== confirmPassword) {
            MessageDialog.Toast("Atenção", "As senhas não são iguais. Digite a mesma senha nos dois campos.");
            return;
        }

        LoaderDialog.Show({
            Message: "Enviando dados ao servidor...",
            Title: "Troca de senha"
        });

        try {
            let result = await API.RequestAsync(`/adm/change-password?n='${password}'&licenseNumber=${CurrentUser.User?.Licence.Number!}`, CurrentUser.Token?.Token ?? "", 'GET');

            await Delay.FromMS(2000);

            LoaderDialog.Close();

            if (!result.ok) {
                MessageDialog.Toast("Atenção", "Erro ao alterar a senha desse usuário.");
                return;
            }

            MessageDialog.Toast("Sucesso", "Senha alterada com sucesso.");
            setPassword("");
            setConfirmPassword("");
        }
        catch {

            LoaderDialog.Close();

            MessageDialog.Toast("Atenção", "Erro ao alterar a senha desse usuário.");
            return;
        }



    }

    console.log(SocketClient.Identification)

    return (
        <div className="PageComponent">

            <Loader />
            <div className="info-page">

                <InfoSection title="Serventia">
                    <InfoItem label="Nome" value={CurrentUser.User?.Licence.Name!} />
                    <InfoItem label="Licença" value={CurrentUser.User?.Licence.Number!} />
                    <InfoItem label="Quantidade de usuários" value="1" />
                </InfoSection>

                <InfoSection title="Usuário">
                    <InfoItem label="Usuário logado" value={CurrentUser.User?.Name!} />
                    <InfoItem label="Perfil" value="Administrador" />
                </InfoSection>

                <InfoSection title="DOC-Mobile">



                    <InfoItem label="Número de sincronização" value={SocketClient.NumeroDeSincronizacao.toString()} />

                    <InfoItem label="Status" value={SocketClient.ID ? "Online" : "Offline"} />


                </InfoSection>

                <InfoSection title="DOC-Windows">

                    {
                        SocketClient.IsDOCWindowsOnline && !!SocketClient.DOCWindowsIdentification?.NumeroDeSincronizacao &&
                        <InfoItem label="Número de sincronização" value={SocketClient.DOCWindowsIdentification?.NumeroDeSincronizacao!.toString()} />
                    }

                    {
                        SocketClient.IsDOCWindowsOnline && !!!SocketClient.DOCWindowsIdentification?.NumeroDeSincronizacao &&
                        <InfoItem label="Número de sincronização" value="0" />
                    }

                    {
                        !SocketClient.IsDOCWindowsOnline &&
                        <InfoItem label="Número de sincronização" value="0" />
                    }

                    <InfoItem label="Status" value={machineInfo.Online ? "Online" : "Offline"} />
                </InfoSection>

                <section className="info-section">
                    <h3 className="section-title">Redefinir senha</h3>

                    <div className="section-content password-section">

                        <div className="password-field">
                            <label>Nova senha</label>
                            <div className="password-input">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                />
                                <i
                                    className={showPassword ? "header-icon pi pi-eye-slash" : "header-icon pi pi-eye"}
                                    onClick={() => setShowPassword(!showPassword)}
                                    title={showPassword ? "Ocultar senha" : "Visualizar senha"}
                                ></i>
                            </div>
                        </div>

                        <div className="password-field">
                            <label>Confirmar senha</label>
                            <div className="password-input">
                                <input
                                    type={showConfirmPassword ? "text" : "password"}
                                    value={confirmPassword}
                                    onChange={e => setConfirmPassword(e.target.value)}
                                />
                                <i
                                    className={showConfirmPassword ? "header-icon pi pi-eye-slash" : "header-icon pi pi-eye"}
                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    title={showConfirmPassword ? "Ocultar senha" : "Visualizar senha"}
                                ></i>
                            </div>

                        </div>

                        <Button Text='Redenifir'
                            OnClickEventHandler={handleChangePassword}
                            Type='Save'

                        />



                    </div>
                </section>

            </div>

        </div>
    );
}
